import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { assistanceCleanSaved, cleanAssistancesPaginatedS } from "../../app/actions/assistanceActions";
import { closeViewModalAction } from "../../app/actions/viewModalActions";
import useActiveSpecialistRole from "../../app/hooks/useActiveSpecialistRole";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsAssistance = ({ page }) => {

  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);
    const { isSpecialistFeeder } = useSelector((state) => state.userRole.roleLogin);
  const { flowEngineEnabled, canCreate } = useActiveSpecialistRole();
  const canShowCreateButton = flowEngineEnabled ? canCreate : isSpecialistFeeder;

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    if (icon === "new") {
      trackEvent({ component: "NewAssistances", event: "NewAssistances-Clicked" });
      dispatch(assistanceCleanSaved());
    } else if (icon === "list") {
      trackEvent({ component: "ListAssistances", event: "ListAssistances-Clicked" });
    } else if (icon === "view") {
          
          trackEvent({ component: "ViewAssistances", event: "EndUserSearch-Clicked" });
          dispatch(cleanAssistancesPaginatedS());
        }

    dispatch(closeViewModalAction());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listAssistance" && canShowCreateButton && (
        <Link
          data-tip
          data-for="newAssistanceTip"
          to="/specialist-assistance/new-assistance"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newAssistance" && (
        <Link data-tip data-for="listAssistanceTip" to="/specialist-assistance/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("list")}>
          <i className={`fa fa-table fa-2x  ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "viewText" && (
        <Link data-tip data-for="viewTip" to="/end-user-search/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("view")}>
          <i className={`fa fa-arrow-left fa-2x  ${iconActiveStyle("view")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "viewHierarchical" && (
        <Link data-tip data-for="viewTip" to="/client-search-hierarchical/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("view")}>
          <i className={`fa fa-arrow-left fa-2x  ${iconActiveStyle("view")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editAssistance" && (
        <div className="navbar-module-actions">
          <Link data-tip data-for="listAssistanceTip" to="/specialist-assistance/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("list")}>
            <i className={`fa fa-table fa-2x  ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>

          {canShowCreateButton && (
            <Link
              data-tip
              data-for="newAssistanceTip"
              to="/specialist-assistance/new-assistance"
              className="p-2 bd-highlight"
              onClick={() => handleActiveIcon("new")}
            >
              <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
            </Link>
          )}
        </div>
      )}

      <ReactTooltip id="newAssistanceTip" place="left" effect="solid">
        {t("assistance.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listAssistanceTip" place="left" effect="solid">
        {t("assistance.page.list")}
      </ReactTooltip>
      <ReactTooltip id="viewTip" place="left" effect="solid">
        {t("view.information.return")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsAssistance;